import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffSliders = () => import('./staff/elements/crudSliders')
const ViewStaffPopups = () => import('./staff/elements/crudPopups')
const ViewStaffDownloads = () => import('./staff/elements/crudDownloads')
const ViewStaffPaymentMethods = () => import('./staff/elements/crudPaymentMethods')
const ViewStaffPages = () => import('./staff/crudPages')
const ViewStaffPagesBlocks =() => import('./staff/crudPagesBlocksContents')
const ViewStaffSettings =() => import('./staff/crudSettings')
const ViewStaffBlocks =() => import('./staff/crudBlocks')
const ViewStaffStoreDeliveries =() => import('./staff/crudStoreDeliveries')
const ViewStaffStoreDiscounts =() => import('./staff/crudStoreDiscounts')
const ViewStaffPortabilityTemplate =() => import('./staff/crudPortabilityTemplate')
const ViewStaffTemplate =() => import('./staff/crudTemplate')

Vue.use(Router)

const router =
  [
    {
      path: '/st/contents',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'ContentsSttaffDashboard',
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web',
          }                                  
        },   
        {
          path: 'sliders',
          name: 'ContentsSttaffSliders',
          component: ViewStaffSliders,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Sliders',
          }                                  
        },   
        {
          path: 'popups',
          name: 'ContentsSttaffPopups',
          component: ViewStaffPopups,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Popups',
          }                                  
        },   
        {
          path: 'downloads',
          name: 'ContentsSttaffDownloads',
          component: ViewStaffDownloads,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Descargas',
          }                                  
        },  
        {
          path: 'payment-methods',
          name: 'ContentsSttaffPaymentMethods',
          component: ViewStaffPaymentMethods,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Métodos de Pago',
          }                                  
        },    
        {
          path: 'pages',
          name: 'ContentsSttaffPages',
          component: ViewStaffPages,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Páginas',
          }                                  
        },    
        {
          path: 'pages-block/:blockID',
          name: 'ContentsSttaffConfiguratePagesBlocks',
          component: ViewStaffPagesBlocks,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Bloques de Páginas',
          }                                  
        },    
        {
          path: 'settings',
          name: 'ContentsSttaffSettings',
          component: ViewStaffSettings,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Configuración',
          }                                  
        },
        {
          path: 'blocks',
          name: 'ContentsSttaffBlocks',
          component: ViewStaffBlocks,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Bloques',
          }                                  
        },        
        {
          path: 'store-deliveries',
          name: 'ContentsSttaffStoreDeliveries',
          component: ViewStaffStoreDeliveries,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Entregas',
          }                                  
        },
        {
          path: 'store-discounts',
          name: 'ContentsSttaffStoreDiscounts',
          component: ViewStaffStoreDiscounts,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Descuentos',
          }                                  
        },                
        {
          path: 'portability-template',
          name: 'ContentsStaffPortabilityTemplate',
          component: ViewStaffPortabilityTemplate,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Portabilidad',
          }                                  
        },        
        {
          path: 'template',
          name: 'ContentsStaffTemplate',
          component: ViewStaffTemplate,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Sitio Web - Plantilla',
          }                                  
        },                            
      ]
    },

    {
      path: '/cu/contents',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/contents',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
